/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatVulnerabilityDateRangeQueryOperator extends models.QueryOperator {
    getFixupPrototypeFunction() { return ThreatVulnerabilityDateRangeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ThreatVulnerabilityDateRangeQueryOperator>): ThreatVulnerabilityDateRangeQueryOperator {
        let obj = Object.assign(new ThreatVulnerabilityDateRangeQueryOperator(), model);
        ThreatVulnerabilityDateRangeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatVulnerabilityDateRangeQueryOperator>): ThreatVulnerabilityDateRangeQueryOperator {
        if (!model) return null;
        return ThreatVulnerabilityDateRangeQueryOperator.newInstance(<ThreatVulnerabilityDateRangeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatVulnerabilityDateRangeQueryOperator) {
        if (!obj) return;

        models.ThreatVulnerabilityDateRangeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatVulnerabilityDateRangeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatVulnerabilityDateRangeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.greater_than_or_equal_to === "string") {
            this.greater_than_or_equal_to = new Date(<string><any>this.greater_than_or_equal_to);
        }
        if (typeof this.less_than_or_equal_to === "string") {
            this.less_than_or_equal_to = new Date(<string><any>this.less_than_or_equal_to);
        }
    }

    /**
     * Lower bound (inclusive) of the date range
     */
    greater_than_or_equal_to: Date;

    /**
     * Upper bound (inclusive) of the date range
     */
    less_than_or_equal_to: Date;

}
